import { afterNextRender, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { Router, RouterModule, TitleStrategy } from '@angular/router';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SearchComponent } from 'app/layout/common/search-widget/search.component';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { DealsType01Component } from '../../deals/deals-type01/deals-type01.component';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { NgClass, NgIf } from '@angular/common';
import { StayListComponent } from 'app/layout/common/list-stay/stay-list.component';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';
import { Subject, takeUntil } from 'rxjs';

import { DestinationListType02Component } from '../../destination-list/destination-list-type02/destination-list-type02.component';
import { DealsType02Component } from '../../deals/deals-type02/deals-type02.component';
import { ArticlesType01Component } from '../../articles/articles-type01/articles-type01.component';
import { ArticlesType02Component } from '../../articles/articles-type02/articles-type02.component';
import { BannerType01Component } from '../../banner/banner-type01/banner-type01.component';
import { BannerType02Component } from '../../banner/banner-type02/banner-type02.component';
import { BannerType03Component } from '../../banner/banner-type03/banner-type03.component';
import { BannerType04Component } from '../../banner/banner-type04/banner-type04.component';
import { TestimonialType01Component } from '../../testimonial/testimonial-type01/testimonial-type01.component';
import { ServicesType01Component } from '../../services/services-type01/services-type01.component';
import { CountersType01Component } from '../../counter/counters-type01/counters-type01.component';
import { PopularHotelsType01Component } from '../../popular-hotels/popular_hotels-type01/popular_hotels-type01.component';
import { FlightDealsType01Component } from '../../flight-deals/flight_deals-type01/flight_deals-type01.component';
import { WhyUsType01Component } from '../../why-us/why_us-type01/why_us-type01.component';
import { WhyUsType02Component } from '../../why-us/why_us-type02/why_us-type02.component';
import { TravelDealsType01Component } from '../../travel-deals/travel_deals-type01/travel_deals-type01.component';
import { ServicesType02Component } from '../../services/services-type02/services-type02.component';
import { MembersType01Component } from '../../members/members-type01/members-type01.component';
import { DealsType03Component } from '../../deals/deals-type03/deals-type03.component';
import { ArticlesType03Component } from '../../articles/articles-type03/articles-type03.component';
import { ChangeGameType01Component } from '../../change-game/change-game-type01/change-game-type01.component';
import { TestimonialType03Component } from '../../testimonial/testimonial-type03/testimonial-type03.component';
import { XlLeisureTravelComponent } from '../../leisure-travel/xl-leisure-travel/xl-leisure-travel.component';
import { ScrollerSectionType01Component } from "../../scroller-section/scroller_section-type01/scroller_section-type01.component";
import { SlideBannerType01Component } from '../../slide-banner/slide-banner-type01/slide-banner-type01.component';
import { SlideUpPopupComponent } from '../../SlideInPopup/SlideInPopup.component';
import { NewslettersType01Component } from "../../newsletters/newsletters-type01/newsletters-type01.component";
import { NewslettersType02Component } from '../../newsletters/newsletters-type02/newsletters-type02.component';
import { WhyUsType03Component } from '../../why-us/why_us-type03/why_us-type03.component';
import { TestimonialType02Component } from '../../testimonial/testimonial-type02/testimonial-type02.component';
import { TestimonialType04Component } from '../../testimonial/testimonial-type04/testimonial-type04.component';
import { ArticlesType04Component } from '../../articles/articles-type04/articles-type04.component';
import { ServicesType03Component } from "../../services/services-type03/services-type03.component";
import { WhyUsType04Component } from "../../why-us/why_us-type04/why_us-type04.component";
import { NewslettersType03Component } from "../../newsletters/newsletters-type03/newsletters-type03.component";
import { WhyUsType05Component } from "../../why-us/why_us-type05/why_us-type05.component";
import { BannerType05Component } from "../../banner/banner-type05/banner-type05.component";
import { HeadingSectionType02Component } from '../../heading-section/heading_section-type02/heading_section-type02.component';
import { BannerType06Component } from "../../banner/banner-type06/banner-type06.component";

@Component({
    selector: 'app-landing-type01',
    standalone: true,
    imports: [
    MatIconModule,
    SearchComponent,
    MatStepperModule,
    RouterModule,
    DestinationListType01Component,
    DestinationListType02Component,
    DealsType01Component,
    DealsType02Component,
    TestimonialType01Component,
    TestimonialType02Component,
    NgIf,
    StayListComponent,
    NgClass,
    ArticlesType01Component,
    ArticlesType02Component,
    BannerType01Component,
    BannerType02Component,
    BannerType03Component,
    BannerType04Component,
    ServicesType01Component,
    CountersType01Component,
    PopularHotelsType01Component,
    FlightDealsType01Component,
    WhyUsType01Component,
    WhyUsType02Component,
    TravelDealsType01Component,
    ServicesType02Component,
    MembersType01Component,
    DealsType03Component,
    ArticlesType03Component,
    ChangeGameType01Component,
    TestimonialType03Component,
    XlLeisureTravelComponent,
    ScrollerSectionType01Component,
    SlideBannerType01Component,
    SlideUpPopupComponent,
    NewslettersType01Component,
    NewslettersType02Component,
    WhyUsType03Component,
    TestimonialType04Component,
    ArticlesType04Component,
    ServicesType03Component,
    WhyUsType04Component,
    NewslettersType03Component,
    WhyUsType05Component,
    BannerType05Component,
    HeadingSectionType02Component,
    BannerType06Component
],
    templateUrl: './landing-type01.component.html',
    styleUrl: './landing-type01.component.scss',
})
export class LandingType01Component implements OnInit, OnDestroy {
    public view: any = {
        isPopupVisible: false,
    };

    private readonly _destroy$ = new Subject<void>();

    clickCounts: { [key: string]: number } = {};

    /** Top margin class for deals section: when site has no service section, use larger margin so deals sit lower. */
    get dealsSectionMarginClass(): string {
        const s = this.view?.site;
        const sections = s?.profile?.sections;
        if (!sections?.services) return 'mt-48 md:mt-56 lg:mt-64';
        // Services for site 11 render above testimonials; extra top margin before Specials heading.
        if (s?.id === 11) return 'mt-16 md:mt-20 lg:mt-24';
        if (s?.id === 72) return 'mt-12 md:mt-16';
        if (s?.id === 77 || s?.id === 70) return 'mt-6 md:mt-8';
        if (sections?.banner === 5) return '';
        return sections?.searchwidget ? 'mt-16 md:mt-20 lg:mt-24' : '';
    }

    constructor(
        private _tfmCartService: TFMCartService,
        private _cd: ChangeDetectorRef,
        private _router: Router,
        private _tfmService: TFMService,
        private title: Title,
        private metaService: Meta
    ) {
        this.view.features = [];
        this.view.features.push({
            icon: 'mat_outline:workspaces',
            title: 'XL Group',
            text: 'Very best in service delivery and price, as well as providing and supporting intelligent travel solutions that optimize your travel experience.',
        });
        this.view.features.push({
            icon: 'mat_outline:groups',
            title: 'XL Members',
            text: 'Our specialists can tap into years of expertise to save you time and stress offering tailored solutions that streamline the planning and booking process.',
        });
        this.view.features.push({
            icon: 'mat_outline:corporate_fare',
            title: 'XL Corporate',
            text: 'We help clients improve efficiency and drive policy compliance while dedicated consultants provide personalized support throughout the process.',
        });
        this.view.features.push({
            icon: 'mat_outline:travel_explore',
            title: 'XL Leisure',
            text: 'XL Travel’s unique insight, knowledge and experience can’t be found in the pages of travel magazines or even on the net - it’s all ours.',
        });
        this.view.features.push({
            icon: 'mat_outline:language',
            title: 'XL Eco-System',
            text: 'Innovative technology solutions that streamline operations, enhance customer experiences, and improve efficiency.',
        });
        this.view.features.push({
            icon: 'mat_outline:stars',
            title: 'XL Rewards',
            text: 'Loyalty and reward programme designed to incentivise customers, offering benefits such as discounted rates and special promotions.',
        });

        afterNextRender(() => {
            this.loadLandingSite();
            this._tfmService.localAgencySite$
                .pipe(takeUntil(this._destroy$))
                .subscribe(() => this.loadLandingSite());
        });
    }

    /** Load site, profile (banner/search sections), and featured images — re-run when ?ai=&sc= updates localStorage after first paint. */
    private loadLandingSite(): void {
        this._tfmService.getSite().then((res) => {
            this.view.site = res;
            this._tfmService.log(this.view.site);

            if (!this.view.site) {
                return;
            }

            this.title.setTitle(
                this.view.site.name + (this.view?.site.slogan ? ' - ' + this.view.site.slogan : '')
            );

            this.metaService.updateTag({
                name: 'description',
                content: this.view.site.metaDescription,
            });
            this.metaService.updateTag({
                name: 'keywords',
                content: this.view.site.metaKeywords,
            });

            this.view.site.profile = this._tfmService.getSiteProfile(
                this.view.site.profileID
            );
            this._tfmService.log(this.view.site.profile);

            this._tfmService
                .filterAndSend(this.view.site._links, 'site-images')
                .subscribe((imgRes) => {
                    this.view.site.images = imgRes.content;

                    this.view.site.images.forEach((img) => {
                        var imgUrl = this._tfmService.getLink(
                            img._links,
                            'view'
                        );
                        if (imgUrl)
                            img.url = this._tfmService.getLink(
                                img._links,
                                'view'
                            ).href;
                    });
                    this.view.bannerUrl =
                        this.view.site.images.filter(
                            (x) => x.isFeatured && x.isActive
                        ).length > 0
                            ? this.view.site.images.filter(
                                  (x) => x.isFeatured && x.isActive
                              )[0]
                            : null;
                    if (this.view.bannerUrl) {
                        this.view.bannerImageClass =
                            "bg-[url('" + this.view.bannerUrl.url + "')]";
                    }
                    this._cd.detectChanges();
                });
        });
    }

    handleBannerClick(bannerId: string) {
        this.clickCounts[bannerId] = (this.clickCounts[bannerId] || 0) + 1;
        localStorage.setItem('bannerClicks', JSON.stringify(this.clickCounts));
        console.log(`Banner ${bannerId} clicked`, this.clickCounts[bannerId]);
    }


    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    ngOnInit(): void {
        const stored = localStorage.getItem('bannerClicks');
        if (stored) {
            this.clickCounts = JSON.parse(stored);
        }
        setTimeout(() => {
            this.view.isPopupVisible = true;
        }, 3000);
    }
    onPopupClosed() {
        this.view.isPopupVisible = false;
    }
    selectedTab: string = 'flight'; // Default tab

    selectTab(tab: string) {
        this.view.selectedTab = tab;
        this._cd.detectChanges();
    }

    public tripChanged(tripData) {
        // this._tfmService.log(tripData);

        this.view.trip = tripData;

        this._tfmCartService.updateTrip(this.view.trip);

        this.redirectToResults();
    }
    public searchChanged(searchData) {
        // this._tfmService.log(searchData);

        this.view.search = searchData;

        this.redirectToResults();
    }
    public resultChanged() {}

    public redirectToResults() {
        if (this.view.trip && this.view.search) {
            //Do redirect....
            this._router.navigateByUrl('/search-results', {
                state: { view: this.view, type: this.view.selectedTab },
            });
        }
    }
}



// 

    
    